var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 px-3 py-1" },
    [
      _c(
        "b-button-group",
        [
          _c(
            "b-button",
            {
              attrs: { variant: _vm.checkedNorm === 1 ? "primary" : "" },
              on: {
                click: function ($event) {
                  return _vm.$bus.$emit("change-norm", 1, true)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Webheader.norm_srtp")))]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { variant: _vm.checkedNorm === 2 ? "primary" : "" },
              on: {
                click: function ($event) {
                  return _vm.$bus.$emit("change-norm", 2, true)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Webheader.norm_hrtp")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }